var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChatOnline',{attrs:{"chat-list":_vm.chatList,"username":_vm.username,"is-anon-editor":_vm.isAnonEditor,"is-admin":_vm.isAdminOwn,"is-past":true,"replyMsg":_vm.msg},on:{"on-send-msg":_vm.onSendMsg,"on-is-anon":_vm.onIsAnon}})
}
var staticRenderFns = []

export { render, staticRenderFns }